import React, { useState } from "react";
import AppLayout from "@cloudscape-design/components/app-layout";
import { Flashbar } from "@cloudscape-design/components";
import AppTopNavigation from "../navigation/TopNavigation";
import AppSidebar from "../navigation/AppSidebar";
import PoweredByFooter from "../common/PoweredByFooter";
import CommandPalette from "../common/CommandPalette";
import { useNotification } from "../../context/NotificationContext";

export default function MainLayout({ children }) {
  const [navOpen, setNavOpen] = useState(true);
  const { notifications, removeNotification } = useNotification();

  return (
    <div>
      <CommandPalette />
      <div id="top-nav" style={{ position: "sticky", top: 0, zIndex: 1001 }}>
        <AppTopNavigation />
      </div>
      <AppLayout
        headerSelector="#top-nav"
        navigation={<AppSidebar />}
        navigationWidth={240}
        navigationOpen={navOpen}
        onNavigationChange={({ detail }) => setNavOpen(detail.open)}
        notifications={
          <Flashbar items={notifications.map(n => ({
            ...n,
            onDismiss: () => removeNotification(n.id),
          }))} />
        }
        toolsHide={true}
        content={
          <div style={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
            <div style={{ flex: 1 }}>{children}</div>
            <PoweredByFooter />
          </div>
        }
        ariaLabels={{
          navigation:        "Navigation drawer",
          navigationToggle:  "Open navigation drawer",
          navigationClose:   "Close navigation drawer",
        }}
      />
    </div>
  );
}
